<div class="dialog" role="document" aria-labelledby="media-picker-title">
  <div class="dialog-header">
    <span class="dialog-title" id="media-picker-title">Select image</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>

  <div class="filter-row">
    <div class="field">
      <label class="field-label" id="picker-category-label">Category</label>
      <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
        <mat-select aria-labelledby="picker-category-label" panelClass="ac-select-panel" [disableOptionCentering]="true" [formControl]="category" (selectionChange)="load()">
          <mat-option [value]="''">All</mat-option>
          @for(c of categories; track c){ <mat-option [value]="c">{{ c | titlecase }}</mat-option> }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="field">
      <label class="field-label" for="picker-search">Search</label>
      <input id="picker-search" type="text" class="text-box-active" placeholder="Name" [formControl]="search" />
    </div>
  </div>

  <div class="picker-grid" role="listbox" aria-label="Media images">
    @for(item of filteredMedia(); track item.mediaId){
    <button
      type="button"
      class="pick-card"
      role="option"
      [attr.aria-selected]="item.imageUrl === selectedUrl"
      [class.selected]="item.imageUrl === selectedUrl"
      (click)="select(item)"
      (dblclick)="select(item); use()"
    >
      <img class="thumb" [src]="item.imageUrl" [alt]="item.name" loading="lazy" />
      <span class="pick-name" [title]="item.name">{{ item.name }}</span>
      <span class="pick-meta">{{ item.category | titlecase }} · {{ placeOf(item) }}</span>
    </button>
    } @empty {
    @if(!isLoading){
    <p class="empty-note">No images available. Upload some under Configurations › Media.</p>
    }
    }
  </div>

  <div class="dialog-actions">
    <button type="button" class="ac-secondary-btn" (click)="close()">Cancel</button>
    <button type="button" class="ac-primary-btn" [disabled]="!selectedUrl" (click)="use()">Use image</button>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
